import { ExportToCsv } from "export-to-csv";
import { REPORT_NAMES } from "./enum"
import _ from "underscore";

export const generateReportCSVStructure = (reportData,type) =>{
    const exportData = [];
    
    if([REPORT_NAMES.PERFORMANCE, REPORT_NAMES.WASTAGE].includes(type)){
        reportData.map((item) => {
            let report = {};

            Object.keys(item).forEach(key => {
                if(!['intervalType','key'].includes(key)){
                    report = {...report, [key]: item[key]}
                }
            })

            exportData.push({[item.intervalType]:item.key, ...report});
        });

    } else if([REPORT_NAMES.ACHIEVEMENT,REPORT_NAMES.OEE,'machineUtilization'].includes(type)){
        const data = _.pluck(reportData, type);

        data.map((item,index) => {
            let report = {
                [reportData[index].intervalType]:reportData[index].key
            }

            Object.keys(item).forEach(key => {
                report = {...report, [key]: item[key]}
            })

            exportData.push(report);
        });
    }else if(type === REPORT_NAMES.DOWNTIME){
        reportData.map((item) => {
            let report = {};
            let reasons = {}

            Object.keys(item.reasons).forEach(key => {
                reasons = {...reasons, [key]: item.reasons[key]}
            })
            
            Object.keys(item).forEach(key => {
                if(!['intervalType','key','reasons'].includes(key)){
                    report = {...report, [key]: item[key]}
                }
            })

            exportData.push({[item.intervalType]:item.key, ...report, ...reasons});
        });
    }else if (type === REPORT_NAMES.AVERAGE_ORDER_SIZE){
        reportData.map((item) => {
            let report = {};
            let lengthAndJobs = {}

            Object.keys(item.lengthAndNoOfJobs).forEach(key => {
                lengthAndJobs = {...lengthAndJobs, [key]: item.lengthAndNoOfJobs[key]}
            })
            
            Object.keys(item).forEach(key => {
                if(!['intervalType','key','noOfColorsAndJobs','lengthAndNoOfJobs'].includes(key)){
                    report = {...report, [key]: item[key]}
                }
            })

            exportData.push({[item.intervalType]:item.key, ...report, ...lengthAndJobs});
        });
    }

    const opt = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true,
        showTitle: false,
        title: performance,
        useBom: true,
        noDownload: false,
        headers: Object.keys(exportData[0]),
        filename: type,
        nullToEmptyString: true,
    };

    const csvExporter = new ExportToCsv(opt);
    csvExporter.generateCsv(exportData);

}